module.exports = __webpack_public_path__ + "img/calendar.a9510479.svg";